import React from 'react';
import { getTempIndicator, getTempClass } from '../../../utils/helpers';

const Temp2mRow = ({dayData, units, data}) => {

    return (
        <tr className="hover:bg-custom-darker/50 transition-colors">
            <td className="pl-2 py-1 text-xs text-custom-light-grey ">
                <div className="inline-flex items-center gap-2 font-medium">
                    <div>
                        <span className="block sm:hidden">Temp</span>
                        <span className="hidden sm:inline-block">Temperature&nbsp;</span>
                        {units && <span className="text-custom-light-grey/70">({units})</span>}
                    </div>
                </div>
            </td>
            {dayData.map(({ index }) => {
                const temperature = data?.[index];
                const tempIndicator = getTempIndicator(temperature);
                return (
                    <td key={index} className="py-1 text-center">
                        <div className="inline-flex flex-col items-center gap-1">
                            {/* <div className="flex justify-center">{tempIndicator}</div> */}
                            <div className={`inline-block min-w-[30px] text-center text-sm font-medium ${getTempClass(temperature)}`}>
                                {Math.round(temperature)}°
                            </div>
                        </div>
                    </td>
                );
            })}
        </tr>
    )
}

export default Temp2mRow;